const ADDIN_STATE_KEY = "snoooz_outlook_addin_state";
const ADDIN_REGION_KEY = "snoooz_outlook_addin_region";
const ADDIN_LANGUAGE_KEY = "snoooz_outlook_addin_language";

function getStorage() {
  try {
    const storage = window.localStorage;
    const key = "__snoooz_storage_test__";

    storage.setItem(key, "1");
    storage.removeItem(key);

    return storage;
  } catch {
    return null;
  }
}

export async function getAddinState() {
  try {
    const storage = getStorage();
    if (!storage) return null;

    const raw = storage.getItem(ADDIN_STATE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export async function saveAddinState(state) {
  try {
    const storage = getStorage();
    if (!storage) return;

    storage.setItem(ADDIN_STATE_KEY, JSON.stringify(state));
  } catch (err) {
    console.warn("Could not save add-in state:", err);
  }
}

export async function clearAddinState() {
  try {
    const storage = getStorage();
    if (!storage) return;

    storage.removeItem(ADDIN_STATE_KEY);
  } catch (err) {
    console.warn("Could not clear add-in state:", err);
  }
}

export function getSavedRegion() {
  try {
    const storage = getStorage();
    if (!storage) return "";

    return storage.getItem(ADDIN_REGION_KEY) || "";
  } catch {
    return "";
  }
}

export function saveRegion(region = "") {
  try {
    const storage = getStorage();
    if (!storage) return;

    if (region) {
      storage.setItem(ADDIN_REGION_KEY, region);
    }
  } catch {
    // ignore storage errors
  }
}

export function getSavedLanguage() {
  try {
    const storage = getStorage();
    if (!storage) return "";

    return storage.getItem(ADDIN_LANGUAGE_KEY) || "";
  } catch {
    return "";
  }
}

export function saveLanguage(language = "") {
  try {
    const storage = getStorage();
    if (!storage) return;

    if (language) {
      storage.setItem(ADDIN_LANGUAGE_KEY, language);
    }
  } catch {
    // ignore storage errors
  }
}